import {
  Box,
  Flex,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';

import { AggregatedLimitedPartnerCommitmentsTableContainer } from './AggregatedLimitedPartnerCommitmentsTable';
import { AliasMatchingAlert } from './AliasMatchingAlert';
import {
  LimitedPartnerFiltersDrawer,
  INITIAL_FILTER_FORM_STATE,
} from './LimitedPartnerFiltersDrawer';
import { LimitedPartnerPortfolioSummaryCards } from './LimitedPartnerPortfolioSummaryCards';
import { LimitedPartnerSearch } from './LimitedPartnerSearch';
import { LimitedPartnersPortfolioOverviewGraphContainer } from './LimitedPartnersPortfolioOverviewGraph';
import { Icon } from 'packages/common-frontend/components/icons';
import { Typography } from 'packages/common-frontend/components/Typography';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { MultiEntityDrawer as LimitedPartnerMultiEntityDrawer } from '~/core/routes/limited-partners/EntityEventLogDrawers';
import { dashboardRoutePadding } from '~/packages/common-frontend/constants';

export const ActionsMenu = () => {
  const navigate = useNavigate();
  return (
    <Menu>
      <MenuButton
        as={Button}
        rightIcon={<Icon icon="chevron-down" />}
        variant="outline"
        colorScheme="v2-aurora"
        border="2px"
      >
        Actions
      </MenuButton>
      <MenuList zIndex={10}>
        <MenuItem
          onClick={() => {
            navigate('/limited-partners/alias-matching');
          }}
        >
          Match LP Alias
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export const LimitedPartnersDashboard = () => {
  const { user } = useUserAuthOrThrow();
  const navigate = useNavigate();

  const [activeFilters, setActiveFilters] = useState(INITIAL_FILTER_FORM_STATE);

  return (
    <Box padding={dashboardRoutePadding}>
      <AliasMatchingAlert />
      <Flex justifyContent="space-between">
        <Typography variant="page-title" trim>
          Limited Partners
        </Typography>
        <Flex gap="1.5rem">
          <LimitedPartnerSearch
            lenderOrganizationId={user.organizationId}
            minWidth="20rem"
            onSelect={(limitedPartnerId) => {
              // Navigate to the limited partner details page
              navigate(`/limited-partners/details/${limitedPartnerId}`);
            }}
            inputPlaceholder="Search all LPs"
          />
          <LimitedPartnerFiltersDrawer
            activeFilters={activeFilters}
            onApplyFilters={setActiveFilters}
          />
          <ActionsMenu />
          <LimitedPartnerMultiEntityDrawer />
        </Flex>
      </Flex>
      <LimitedPartnerPortfolioSummaryCards
        lenderOrganizationId={user.organizationId}
        activeFilters={activeFilters}
      />
      <Flex justifyContent="flex-end">
        <Button
          as={RouterLink}
          to="/limited-partners/commitments"
          mt="1.5rem"
          variant="link"
          colorScheme="blue"
          rightIcon={<Icon icon="chevron-right" />}
          textDecoration="none"
          _hover={{ textDecoration: 'underline' }}
        >
          View LP Commitments
        </Button>
      </Flex>
      <LimitedPartnersPortfolioOverviewGraphContainer
        lenderOrganizationId={user.organizationId}
      />
      <AggregatedLimitedPartnerCommitmentsTableContainer
        activeFilters={activeFilters}
      />
    </Box>
  );
};
